/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SourceDestinationWeight } from "./SourceDestinationWeight";
export const SourceDestinationWeights = core.serialization.object({
    weights: core.serialization.list(SourceDestinationWeight),
});
